import { render } from "./forget_password.vue?vue&type=template&id=0d1275a3&scoped=true"
import script from "./forget_password.vue?vue&type=script&lang=js"
export * from "./forget_password.vue?vue&type=script&lang=js"

import "./forget_password.vue?vue&type=style&index=0&id=0d1275a3&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1275a3"]])

export default __exports__